import React from 'react';
export const ModalContext = React.createContext({});
export const { Provider: ModalContextProvider } = ModalContext;
